import es_ES from './es_ES.json';
import ca_ES from './ca_ES.json';
import eu_ES from './eu_ES.json';
import gl_ES from './gl_ES.json';
import en_GB from './en_GB.json';

const messages = {
  'es-ES': es_ES,
  'ca-ES': ca_ES,
  'eu-ES': eu_ES,
  'gl-ES': gl_ES,
  'en-GB': en_GB,
};

export default messages;
